<template>
  <div>
    <b-form @submit="onSubmit" @reset="onReset" v-if="show">
      <b-form-group id="input-group-1" label="Email (*)" label-for="input-1">
        <b-form-input
          id="input-1"
          v-model="form.from_email"
          type="email"
          required
          placeholder="Votre email"
        ></b-form-input>
      </b-form-group>

      <b-form-group id="input-group-2" label="Nom (*)" label-for="input-2">
        <b-form-input id="input-2" v-model="form.from_name" required placeholder="Votre nom"></b-form-input>
      </b-form-group>

      <b-form-group id="input-group-2" label="Téléphone:" label-for="input-2">
        <b-form-input id="input-2" v-model="form.from_phone" placeholder="Votre téléphone"></b-form-input>
      </b-form-group>

      <b-form-group id="input-group-2" label="Message (*)" label-for="input-2">
        <b-form-textarea
          id="input-2"
          v-model="form.text"
          required
          placeholder="Votre message"
          rows="3"
          max-rows="6"
        ></b-form-textarea>
      </b-form-group>

      <b-button type="submit" variant="primary">Envoyer</b-button>
    </b-form>
  </div>
</template>

<script>
import axios from "axios";

const instance = axios.create({
  baseURL: "https://api.cabinet-aurore-magelys.fr",
  timeout: 3000
});

export default {
  data() {
    return {
      form: {
        from_email: "",
        from_name: "",
        from_phone: "",
        text: ""
      },
      show: true
    };
  },
  methods: {
    sendMail() {
      instance
        .post("/send", this.form)
        .then(function(response) {
          console.log(response);
          alert(
            "Votre message a été pris en compte. Il sera traité dans les meilleurs délais."
          );
        })
        .catch(function(error) {
          console.log(error);
          alert(
            "Votre message n'a pas pu être délivré. Merci d'envoyer directement un e-mail à l'adresse orthoptie.smh@gmail.com."
          );
        });
    },
    onSubmit(evt) {
      evt.preventDefault();
      this.sendMail();
    },
    onReset(evt) {
      evt.preventDefault();
      // Reset our form values
      this.form.from_email = "";
      this.form.from_name = "";
      this.form.from_phone = "";
      // Trick to reset/clear native browser form validation state
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    }
  }
};
</script>
